import {type EnvironmentProviders, inject} from '@angular/core'
import {provideGallery, provideGalleryDataAdapter, provideGalleryServiceAdapter} from '@uve-solutions/f-gallery/app'
import {CartGalleryDataAdapter} from './adapters/cart-gallery-data.adapter'
import {CartGalleryServiceAdapter} from './adapters/cart-gallery-service.adapter'

/* La galería de cart es de solo lectura (paridad con la legacy, que iba en showHeader mode 'view'):
 * los permisos de escritura van a false y los métodos de escritura de los adapters no son alcanzables. */
export function provideCartGallery(): EnvironmentProviders[] {
  return [
    provideGallery({
      permissions: {canCreate: false, canUpdate: false, canDelete: false},
      toolbar: {
        show: false,
        showTitle: false,
        title: '',
        showSearch: false,
        showFilters: false,
        showViewToggle: false,
        showSort: false,
        showBulkActions: false,
        hideTableView: true,
        mode: 'view',
      },
      showRecentFiles: true,
      showBreadcrumbs: false,
    }),
    provideGalleryDataAdapter(() => inject(CartGalleryDataAdapter)),
    provideGalleryServiceAdapter(() => inject(CartGalleryServiceAdapter)),
  ]
}
